import { CircleAlert, CircleCheck, CircleX } from 'lucide-react'
import { useTheme } from 'next-themes'
import { Toaster as Sonner } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'bg-muted border border-muted-foreground/10 text-foreground shadow-lg',
          description: 'text-muted-foreground',
          actionButton: 'bg-primary text-primary-foreground',
          cancelButton: 'bg-muted text-muted-foreground',
        },
      }}
      icons={{
        success: <CircleCheck className="h-4 w-4 text-primary" />,
        warning: <CircleAlert className="h-4 w-4 text-yellow-500" />,
        error: <CircleX className="h-4 w-4 text-destructive" />,
      }}
      {...props}
    />
  )
}

export { Toaster }
